import {weaponMotion,type SuperAction} from '../../shared/weapon-motion';

/** Preserve every impact and hold through the final hit, then play the authored
 * return at a brisker rate. The source clips and fitting-room clocks stay exact. */
function recovery(action:SuperAction){
 const clip=weaponMotion('sword',action);
 return {end:clip.duration,start:Math.min(clip.duration,clip.contacts.at(-1)!+.14),speed:2.4};
}
export function abilityDuration(action:SuperAction):number {
 const r=recovery(action);return r.start+(r.end-r.start)/r.speed;
}
export function abilityTime(action:SuperAction,seconds:number):number {
 const r=recovery(action);return Math.min(r.end,Math.max(0,seconds<=r.start?seconds:r.start+(seconds-r.start)*r.speed));
}
export function abilityEventAt(action:SuperAction,sourceSeconds:number):number {
 const r=recovery(action);return sourceSeconds<=r.start?sourceSeconds:r.start+(sourceSeconds-r.start)/r.speed;
}
